import React, { useState } from 'react';

import useCurrentWpPlatform from '@dashboard/hooks/useCurrentWpPlatform';
import { ExpandMoreOutlined } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';

import TogglePlatformHaltRow from './TogglePlatformHaltRow';

export default function DangerZoneCard() {
  const { data } = useCurrentWpPlatform();
  const [expanded, setExpanded] = useState(false);

  const platform = data?.Platform;
  if (!platform) {
    return null;
  }

  const isPaidTier = !['FREE', 'SAMPLE', 'SANDBOX'].includes(platform.activeWaypointTier);
  if (!isPaidTier) {
    return null;
  }

  return (
    <Box id="danger-zone" sx={{ scrollMarginTop: 3 }}>
      <Accordion
        expanded={platform.isHalted || expanded}
        onChange={(_, val) => setExpanded(val)}
        disableGutters
        sx={{ px: { xs: 3, md: 4 }, py: 3 }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreOutlined />}
          sx={{ p: 0, flexDirection: 'row-reverse', justifyContent: 'flex-end', gap: 1 }}
        >
          <Typography variant="h4">Danger zone</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ px: 0, py: 1 }}>
          <TogglePlatformHaltRow platform={platform} />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
